import { styled } from "@mui/material";
import { INK } from "../../theme/tokens";

export const LoginSeparator = styled("span")({
	width: "100%",
	display: "flex",
	justifyContent: "space-evenly",
	alignItems: "center",
	gap: "10px",
	"::before": {
		content: "''",
		flex: "1 1 0",
		height: "1px",
		backgroundColor: INK.SECONDARY,
	},
	"::after": {
		content: "''",
		flex: "1 1 0",
		height: "1px",
		backgroundColor: INK.SECONDARY,
	},
});
